import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppWithNavbar from './AppWithNavbar';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWithNavbar />
  </React.StrictMode>
);

reportWebVitals();
